













































import {Vue, Component, Prop} from 'vue-property-decorator'
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import QInput, {Loading} from 'quasar';
import ITodoCollection, {ITodo} from '@/models/todoCollection';
import { mapGetters } from "vuex";
import firebase from 'firebase';
import DocumentModule from '@/store/application/DocumentModule';
import QuizViewModule from '../store/view/QuizViewModule';
import HomeViewModule from '@/store/view/HomeViewModule';


@Component({
    filters: {
        truncateBody(value: string) {
            if (value.length > 230) {
                return value.slice(0, 230) + '...';
            } else {
                return value;
            }
        }
    }
})
export default class Quiz extends Vue {
	public currentCard: number = 0;
	public rightAnswer: number = 0;
	public wrongAnswer1: number = 0;
	public wrongAnswer2: number = 0;
	public aColor: string = 'grey-2';
	public bColor: string = 'grey-2';
	public cColor: string = 'grey-2';
	public success: boolean = false;
	public alreadyGuessed: boolean = false;

	public get score() {
		return QuizViewModule.score;
	}

	public get clicks() {
		return QuizViewModule.clicks;
	}

	public get tasks(): ITodo[] {
		return DocumentModule.tasks;
	}
	
	public get document(): ITodoCollection {
		return DocumentModule.document;
	}

	public get user() {
		return this.$store.getters.user;
	}

	public get title() {
		if (this.tasks[this.currentCard].title) {
			return this.tasks[this.currentCard].title;
		} else {
			return ''
		}
	}

	public randomRightAnswerLocationGenerator() {
		if (this.tasks[this.currentCard].body) {
			this.rightAnswer = Math.ceil(Math.random() * 3);
		}
	}

	public randomWrongAnswerGenerator() {
		if (this.tasks[this.currentCard].body) {
			do {
				this.wrongAnswer1 = Math.ceil(Math.random() * this.tasks.length -1);
			} while (this.wrongAnswer1 === this.currentCard && this.tasks.length >= 3);
			do { 
				this.wrongAnswer2 = Math.ceil(Math.random() * this.tasks.length -1);
			} while ((this.wrongAnswer2 === this.wrongAnswer1 || this.wrongAnswer2 === this.currentCard) && this.tasks.length >= 3);
		}
	}

	public get answerA() {
		switch (this.rightAnswer) {
			case 1: 
				return this.tasks[this.currentCard].body;
			case 2:
				return this.tasks[this.wrongAnswer1].body;
			case 3:
				return this.tasks[this.wrongAnswer2].body;
			default:
				return this.tasks[this.currentCard].body;
		}
	}

	public get answerB() {
		switch (this.rightAnswer) {
			case 1: 
				return this.tasks[this.wrongAnswer1].body;
			case 2:
				return this.tasks[this.currentCard].body;
			case 3:
				return this.tasks[this.wrongAnswer1].body;
			default:
				return this.tasks[this.wrongAnswer1].body;
		}
	}

	public get answerC() {
		switch (this.rightAnswer) {
			case 1: 
				return this.tasks[this.wrongAnswer2].body;
			case 2:
				return this.tasks[this.wrongAnswer2].body;
			case 3:
				return this.tasks[this.currentCard].body;
			default:
				return this.tasks[this.wrongAnswer2].body;

		}
	}

	public select(choice: string) {
		switch (this.rightAnswer) {
			case 1:
				this.aColor = 'positive';
				this.bColor = 'negative';
				this.cColor = 'negative';
				break;
			case 2:
				this.aColor = 'negative';
				this.bColor = 'positive';
				this.cColor = 'negative';
				break;
			case 3:
				this.aColor = 'negative';
				this.bColor = 'negative';
				this.cColor = 'positive';
				break;
			default: 		
		}
		switch (choice) {
			case 'A': 
				if (this.rightAnswer === 1 && this.alreadyGuessed !== true) {
					QuizViewModule.addPoint();
					this.success = true;
				} 
				break;
			case 'B':
				if (this.rightAnswer === 2 && this.alreadyGuessed !== true) {
					QuizViewModule.addPoint();
					this.success = true;
				} 
				break;
			case 'C':
				if (this.rightAnswer === 3 && this.alreadyGuessed !== true) {
					QuizViewModule.addPoint();
					this.success = true;
				} 
				break;
			default:		
		}
		QuizViewModule.click();
		this.alreadyGuessed = true;
	}

	public onNext(success: boolean, element: any) {
		switch(success) {
			case true:
				this.tasks.push(this.tasks.splice(this.tasks.indexOf(element), 1)[0]);
				break;
			case false:
				this.tasks.splice(this.tasks.indexOf(element), 1);
				this.tasks.splice(this.tasks.indexOf(element) + (this.tasks.length/2), 0, element);
			break;
		}
		// Reset state
		this.aColor = 'grey-2';
		this.bColor = 'grey-2';
		this.cColor = 'grey-2';
		this.success = false;
		this.alreadyGuessed = false;
		this.randomRightAnswerLocationGenerator();
		this.randomWrongAnswerGenerator();
	}

	public resetScore() {
		QuizViewModule.resetScore();
	}

	public async loadData() {
		this.randomRightAnswerLocationGenerator();
		this.randomWrongAnswerGenerator();
	}

	beforeCreate() {
		firebase.auth().onAuthStateChanged(async () => {
			Loading.show();
            await HomeViewModule.loadDocuments(this.$store.getters.user);
			await DocumentModule.loadDocument(this.$route.params.id);
			Loading.hide();
			this.loadData();
        })
	}

}

